var SimulateRemoteWeatherService = /** @class */ (function () {
    function SimulateRemoteWeatherService(virtualDeviceWeatherService) {
        this.virtualDeviceWeatherService = virtualDeviceWeatherService;
    }
    SimulateRemoteWeatherService.prototype.getWeatherInfo = function () {
        var _this = this;
        return new Promise((function (resolve, reject) {
            _this.virtualDeviceWeatherService.getWeatherInfo(0).toPromise().then(function (result) {
                resolve(result);
            }, function (err) {
                reject(err);
            });
        }));
    };
    return SimulateRemoteWeatherService;
}());
export { SimulateRemoteWeatherService };
